import { Component, OnInit, Input } from '@angular/core';
import { camps } from '../../../../models/models.generated';

@Component({
    selector: 'app-capacity-report-item',
    templateUrl: './capacity-report-item.component.html',
    styleUrls: ['./capacity-report-item.component.scss'],
    standalone: false
})
export class CapacityReportItemComponent implements OnInit {

    @Input() public item: camps.CapacityReportInfoItem;

    constructor() { }

    ngOnInit() {
    }

}
